/* eslint-disable no-unused-vars */
import { useEmployeeContext } from "../../../context/employee-context";
import ProfileForm from "./profile-form";
import EmployeeProfileView from "./profile-view";
import useEmployeeProfileService from "./use-profile-service";
function EmployeeProfile() {


  const {
    getInputFieldProps,
    setEmployeeProfileInput,
    fileInputRef,
    previewURL,
    createFormUpdateLoading,
    setSelectedFile,
    setPreviewURL,
    employeeProfileInput,
    handleClick,
    togglePresentAddress,
    EmployeedetailsModalOpen,
    PresentaddressModalClose,
    PresentaddressModalOpen,
    PermanentaddressModalClose,
    PermanentaddressModalOpen,
    PersonalInformationModalClose,
    PersonalInformationModalOpen,
    EmployeedetailsModalClose,
    Permanentaddress,
    PersonalInformation,
    Presentaddress,
    Employeedetails,
    SubmitWithNextBtn,
    SubmitAfterView,
    id,
    isOpenPresentAddForm,
    handleClickPresentAddress,
  } = useEmployeeProfileService();
  const {
    employeeInfo: imployeeInfoFromDB,
    employeeProfileUILoading
  } = useEmployeeContext() || {};


  if (employeeProfileUILoading) {
    return <p>Employee Profile UI Loading.....</p>
  }
 
  return (

    <>
      {!id ? <ProfileForm
        createFormUpdateLoading={createFormUpdateLoading}
        employeeProfileInput={employeeProfileInput}
        getInputFieldProps={getInputFieldProps}
        togglePresentAddress={togglePresentAddress}
        fileInputRef={fileInputRef}
        handleClick={handleClick}
        previewURL={previewURL}
        setEmployeeProfileInput={setEmployeeProfileInput}
        setPreviewURL={setPreviewURL}
        setSelectedFile={setSelectedFile}
        SubmitWithNextBtn={SubmitWithNextBtn}
        SubmitAfterView={SubmitAfterView}
        isOpenPresentAddForm={isOpenPresentAddForm}
        handleClickPresentAddress={handleClickPresentAddress}
      />
        : <EmployeeProfileView
          createFormUpdateLoading={createFormUpdateLoading}
          handleClick={handleClick}
          employeeProfileInput={employeeProfileInput}
          getInputFieldProps={getInputFieldProps}
          EmployeedetailsModalOpen={EmployeedetailsModalOpen}
          PresentaddressModalClose={PresentaddressModalClose}
          PresentaddressModalOpen={PresentaddressModalOpen}
          PermanentaddressModalClose={PermanentaddressModalClose}
          PermanentaddressModalOpen={PermanentaddressModalOpen}
          PersonalInformationModalClose={PersonalInformationModalClose}
          PersonalInformationModalOpen={PersonalInformationModalOpen}
          EmployeedetailsModalClose={EmployeedetailsModalClose}
          Permanentaddress={Permanentaddress}
          PersonalInformation={PersonalInformation}
          Presentaddress={Presentaddress}
          Employeedetails={Employeedetails}
          setEmployeeProfileInput={setEmployeeProfileInput}
          id={id}
        />
        }
    </>
  );
}

export default EmployeeProfile;
